/* eslint-disable react/prop-types */
import React from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import { Base64 } from 'js-base64';
import {
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Button,
} from 'reactstrap';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import toastr from 'toastr';
import { Link } from 'react-router-dom';
import Switch from 'react-switch';
import { FaTrashAlt } from 'react-icons/fa';

import CKEditor from '@ckeditor/ckeditor5-react';
import FontColoredEditor from 'ckeditor5-build-fontcolored/src/ckeditor';

import escapeChars from '../helpers/regex';

import Content from '../components/layout/Content';
import FormError from '../components/formControls/FormError';
import SnipperButton from '../components/buttons/SpinnerButton';
import { getProduct, updateProduct, updateProductWoutFile } from '../api/product';
import { getCategories } from '../api/category';
import { IMG_URL } from '../config';
import Loading from '../components/Loading';

const DeleteButton = styled(FaTrashAlt)`
  top: 0; 
  left: 20px;
  cursor: pointer;
`;

class ProductDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      spinner: false,
      categories: [],
      product: '',
      tags: [],
      checked: false,
      imageUrl: false,
      allergens: ['lupine', 'fish', 'gluten', 'mustard', 'crustacean', 'celery', 'sulfur', 'treenuts', 'peanuts', 'soy', 'sesame', 'milk', 'egg', 'mollusc'],
      addedAllergens: [],
    };

    this.deleteHandlerProduct = this.deleteHandlerProduct.bind(this);
  }

  async componentDidMount() {
    const { match: { params: { productId } } } = this.props;
    const { user } = this.props;
    // const masterUser = user.isAdmin ? user.id : user.masterUserId;
    const masterUser = user && (user.masterUserId || user.id);
    const { data } = await getProduct(productId);
    const { product, tags } = data.data;
    const resCategories = await getCategories(masterUser);
    if (product) {
      if (product.displayPicture) {
        this.setState({ imageUrl: true });
      }

      if (product.allergens && product.allergens.length > 0) {
        if (product.allergens.includes(',')) {
          const allergens = product.allergens.split(',');
          const addedAllergens = [];
          allergens.forEach((allergen) => {
            addedAllergens.push(allergen);
          });

          this.setState({ addedAllergens });
        } else {
          this.setState({ addedAllergens: [product.allergens] });
        }
      }
    }

    this.setState({
      product,
      tags,
      categories: resCategories.data.categories,
      masterUser,
      checked: product.isActive,
    });
  }

  deleteHandlerProduct = async (product) => {
    product.displayPicture = null;

    await updateProductWoutFile(product).then((result) => {
      this.setState({ imageUrl: false });
      const imagefile = document.querySelector('#productImage');
      imagefile.value = '';
      return result;
    }, (error) => {
      console.log('error', error);
      console.log(error.response);
    }).catch((error) => {
      console.log('catch error', error);
    });

    toastr.success('', 'Deleted');
  }

  clickAllergen = (allergen) => {
    const { addedAllergens } = this.state;
    if (addedAllergens.includes(allergen)) {
      addedAllergens.splice(addedAllergens.findIndex((indexes) => indexes === allergen), 1);
    } else {
      addedAllergens.push(allergen);
    }

    this.setState({ addedAllergens });
  }

  render() {
    const { intl } = this.props;

    const {
      product, categories, masterUser, spinner, checked, tags, allergens, addedAllergens,
    } = this.state;

    console.log({ product });

    const category = categories.filter(
      (filterCategory) => filterCategory.id === parseInt(product.categoryId, 10),
    )[0];

    const edited = intl.formatMessage({ id: 'edited' });
    const titleText = intl.formatMessage({ id: 'productDetail.title' });
    const productNameText = intl.formatMessage({ id: 'productDetail.productName' });
    const productDescText = intl.formatMessage({ id: 'productDetail.desc' });
    const productStatusText = intl.formatMessage({ id: 'productDetail.status' });
    const categoryText = intl.formatMessage({ id: 'category' });
    const tagGroupsText = intl.formatMessage({ id: 'taggroups' });
    const portionsText = intl.formatMessage({ id: 'portions' });
    const sambaIDText = intl.formatMessage({ id: 'sambaID' });
    const menuEditText = intl.formatMessage({ id: 'sidebar.menu.edit' });
    const imageScaleText = intl.formatMessage({ id: 'image.scale' });
    const productImageText = intl.formatMessage({ id: 'productDetail.productImage' });
    const editProductText = intl.formatMessage({ id: 'productDetail.editProduct' });
    const allergenText = intl.formatMessage({ id: 'productDetail.selectAllergen' });

    return (
      <Row>
        <Col>
          <Formik
            initialValues={
              {
                displayName: product && product.displayName,
                desc: (product && product.desc) || '',
                categoryId: product && product.categoryId,
                isActive: product && product.isActive,
              }
            }
            enableReinitialize
            onSubmit={async (submit) => {
              this.setState({ spinner: true });
              const { match: { params } } = this.props;
              const data = { ...submit, userId: product.userId };
              const formData = new FormData();
              const imagefile = document.querySelector('#productImage');
              if (imagefile.files[0] !== undefined) {
                formData.append('productImage', imagefile.files[0], escapeChars(imagefile.files[0].name));
              }
              formData.append('displayName', data.displayName);
              formData.append('desc', data.desc);
              formData.append('isActive', checked ? 1 : 0);
              formData.append('userId', data.userId);
              formData.append('categoryId', data.categoryId);
              formData.append('id', params.productId);
              formData.append('allergens', this.state.addedAllergens.join(','));
              const result = await updateProduct(masterUser, formData);
              if (result.error) {
                this.setState({ spinner: false });
                imagefile.value = '';
                return toastr.error(result.error.response.data.error);
              }
              toastr.success(edited);
              imagefile.value = '';
              this.setState({ spinner: false });
            }}
          >
            {({
              values,
              errors,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
              /* and other goodies */
            }) => (
                <Content
                  title={titleText}
                  breads={[
                    { to: '/panel/menu-edit', name: menuEditText },
                    {
                      to: `/panel/category/${category && category.id}`,
                      name: category && category.displayName,
                    },
                    { name: product && product.displayName },
                  ]}
                >
                  {
                    !product ? <Loading />
                      : (
                        <form onSubmit={handleSubmit} encType="multipart/form-data">
                          <FormGroup>
                            <Label for="displayName">{productNameText}</Label>
                            <Input
                              type="text"
                              name="displayName"
                              id="displayName"
                              placeholder={productNameText}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.displayName}
                            />
                            <small>
                              {sambaIDText}
                              :
                              {' '}
                              {product.sambaName}
                            </small>
                            {errors.name && <FormError error={errors.name} />}
                          </FormGroup>
                          <FormGroup>
                            <p htmlFor="displayName">{productStatusText}</p>
                            <Switch
                              onChange={() => this.setState({ checked: !checked })}
                              checked={checked}
                              className="react-switch"
                            />
                            {errors.name && <FormError error={errors.name} />}
                          </FormGroup>
                          <FormGroup>
                            <Label for="desc">
                              {productDescText}
                            </Label>
                            <CKEditor
                              editor={FontColoredEditor}
                              data={values.desc}
                              onInit={(editor) => {
                                editor.setData(values.desc);
                                editor.editing.view.change((writer) => {
                                  writer.setStyle('height', '300px', editor.editing.view.document.getRoot());
                                });
                              }}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                setFieldValue('desc', data);
                              }}
                              config={{
                                toolbar: {
                                  items: [
                                    'heading',
                                    '|',
                                    'bold',
                                    'italic',
                                    'strikethrough',
                                    'underline',
                                    'fontSize',
                                    'fontFamily',
                                    'fontColor',
                                    'fontBackgroundcolor',
                                    '|',
                                    'subscript',
                                    'superscript',
                                    'bulletedList',
                                    'numberedList',
                                    'horizontalLine',
                                    'alignment',
                                    'indent',
                                    'outdent',
                                    '|',
                                    'blockQuote',
                                    'insertTable',
                                    'undo',
                                    'redo',
                                    'removeFormat',
                                  ],
                                },
                                language: 'en',
                                table: {
                                  contentToolbar: [
                                    'tableColumn',
                                    'tableRow',
                                    'mergeTableCells',
                                  ],
                                },
                                licenseKey: '',
                              }}
                            />
                            {errors.desc && <FormError error={errors.desc} />}
                          </FormGroup>
                          <FormGroup>
                            <Label for="categoryId">{categoryText}</Label>
                            <Input
                              type="select"
                              name="categoryId"
                              id="categoryId"
                              value={values.categoryId}
                              onChange={(e) => setFieldValue('categoryId', e.target.value)}
                            >
                              {
                                categories.length > 0
                                  ? categories.map((category) => (
                                    <option
                                      key={category.id}
                                      value={category.sambaId}
                                    >
                                      {category.displayName}
                                    </option>
                                  )) : ''
                              }
                            </Input>
                          </FormGroup>
                          <FormGroup>
                            <Label>{tagGroupsText}</Label>
                            <div>
                              {tags.map((tagGroup) => (
                                <Link key={tagGroup.id} to={`/panel/tag-group/${tagGroup.id}`}>
                                  <TagGroupButton
                                    type="button"
                                    outline
                                    color="info"
                                  >
                                    {tagGroup.displayName}

                                  </TagGroupButton>
                                </Link>
                              ))}
                            </div>
                          </FormGroup>
                          <FormGroup>
                            <Label>{portionsText}</Label>
                            <div>
                              {
                                product.Portions.map((portion) => (
                                  <Link key={portion.id} to={`/panel/portion/${portion.id}`}>
                                    <TagGroupButton
                                      type="button"
                                      outline
                                      color="primary"
                                    >
                                      {portion.displayName}

                                    </TagGroupButton>
                                  </Link>
                                ))
                              }
                            </div>
                          </FormGroup>
                          <FormGroup>
                            <Label>{allergenText}</Label>
                            <div>
                              <Row>
                                {
                                  allergens.map((allergen, index) => {
                                    const allergenText = intl.formatMessage({ id: allergen });
                                    return (
                                      <Col
                                        sm={2}
                                        key={index}
                                        onClick={() => this.clickAllergen(allergen)}
                                        style={{
                                          cursor: 'pointer', margin: '6px', display: 'flex', flexDirection: 'row',
                                        }}
                                      >
                                        <AllergenImg src={`/images/allergens/${allergen}${addedAllergens.includes(allergen) ? '2' : ''}.jpg`} />
                                        <AllergenText isSelected={addedAllergens.includes(allergen)}>{allergenText}</AllergenText>
                                      </Col>
                                    );
                                  })
                                }
                              </Row>
                            </div>
                          </FormGroup>
                          <FormGroup>
                            <Label for="productImage">{productImageText}</Label>
                            <Input
                              type="file"
                              name="productImage"
                              id="productImage"
                              onChange={(event) => {
                                const output = document.getElementById('previewImage');
                                output.src = URL.createObjectURL(event.target.files[0]);
                                setFieldValue('productImage', event.currentTarget.files[0]);
                                this.setState({ imageUrl: true });
                              }}
                            />
                            <div>
                              <small>{imageScaleText}</small>
                            </div>
                            <PreviewImg id="previewImage" src={product.displayPicture ? `${IMG_URL}${Base64.encode(masterUser)}/images/q-${product.displayPicture}` : null} alt="" />

                            {(product.displayPicture || this.state.imageUrl) && <DeleteButton onClick={() => this.deleteHandlerProduct(product)} />}
                          </FormGroup>
                          <SnipperButton type="submit" loading={spinner} text={editProductText} />
                        </form>
                      )
                  }
                </Content>
              )}
          </Formik>
        </Col>
      </Row>
    );
  }
}

const AllergenImg = styled.img`
  border-radius: 10px;
  width: 75px;
  height: 75px;
`;

const AllergenText = styled.span`
  font-weight: ${(props) => (props.isSelected ? 'bold' : null)};
  margin-left: 10px;
`;

const PreviewImg = styled.img`
  margin-top: 20px;
  width: 200px;
`;

const TagGroupButton = styled(Button)`
  margin-right: 10px;
`;

const mapStateToProps = (state) => ({ user: state.auth.user });

export default injectIntl(connect(mapStateToProps)(ProductDetail));
